<script setup lang="ts">
import Theme from "vitepress-theme-async";
const { Layout } = Theme;
</script>
<template>
  <Layout>
    <template #links-after>
      <TrmDividerTitle title="asdasd"
                       index="01" />
    </template>
  </Layout>
</template>
